import * as constants from './constants'

export const setPurchaseData = data => ({
    type: constants.SET_PURCHASE_DATA,
    data,
})

export const getSubscriptionLocation = locationId => ({
    type: constants.GET_SUBSCRIPTION_LOCATION,
    locationId,
})

export const setSubscriptionLocation = data => ({
    type: constants.SET_SUBSCRIPTION_LOCATION,
    data,
})

export const getLocationRates = (startDate, promoCode) => ({
    type: constants.GET_LOCATION_RATES,
    startDate,
    promoCode,
})

export const setLocationRates = (products, waitListProducts, hasPromoPrice = false) => ({
    type: constants.SET_LOCATION_RATES,
    products,
    waitListProducts,
    hasPromoPrice,
})

export const getOrderSummary = data => ({
    type: constants.GET_ORDER_SUMMARY,
    data,
})

export const setOrderSummary = data => ({
    type: constants.SET_ORDER_SUMMARY,
    data,
})

export const getTermsAndConditions = () => ({
    type: constants.GET_TERMS_AND_CONDITIONS,
})

export const setTermsAndConditions = data => ({
    type: constants.SET_TERMS_AND_CONDITIONS,
    data,
})

export const buySubscription = data => ({
    type: constants.BUY_SUBSCRIPTION,
    data,
})

export const addRateToWaitList = (rateId, waitListId, startDate) => ({
    type: constants.ADD_RATE_TO_WAITLIST,
    data: {
        rateId,
        waitListId,
        startDate,
    },
})

export const getCollectAddress = () => ({
    type: constants.GET_COLLECT_ADDRESS,
})

export const setCollectAddress = data => ({
    type: constants.SET_COLLECT_ADDRESS,
    data,
})

export const getSummaryAddress = () => ({
    type: constants.GET_SUMMARY_ADDRESS,
})

export const setSummaryAddress = data => ({
    type: constants.SET_SUMMARY_ADDRESS,
    data,
})
